import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'results', 'organisationId', 'selectedOrg', 'selectedName'];
  static values = { url: String, selectedId: String, selectedName: String };

  connect() {
    this.debounceTimer = null;
    document.addEventListener('click', this.handleClickOutside);

    if (this.selectedIdValue && this.selectedNameValue) {
      this.organisationIdTarget.value = this.selectedIdValue;
      this.selectedNameTarget.textContent = this.selectedNameValue;
      this.selectedOrgTarget.classList.remove('hidden');
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  search() {
    clearTimeout(this.debounceTimer);

    const query = this.inputTarget.value.trim();
    if (query.length < 3) {
      this.hideResults();
      return;
    }

    this.debounceTimer = setTimeout(() => this.fetchResults(query), 300);
  }

  async fetchResults(query) {
    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`);
      const organisations = await response.json();

      if (organisations.length === 0) {
        this.resultsTarget.innerHTML =
          '<div class="px-4 py-3 text-sm text-stone-400">No organisations found</div>';
      } else {
        this.resultsTarget.innerHTML = organisations
          .map(
            (org) =>
              `<button type="button" class="block w-full text-left px-4 py-3 text-sm text-teal-950 hover:bg-teal-50 transition-colors cursor-pointer" data-action="click->organisation-search#select" data-id="${org.id}" data-name="${this.escapeHtml(org.name)}">${this.escapeHtml(org.name)}</button>`
          )
          .join('');
      }

      this.showResults();
    } catch (error) {
      console.error('Organisation search failed:', error);
    }
  }

  select(event) {
    const { id, name } = event.currentTarget.dataset;

    this.organisationIdTarget.value = id;
    this.selectedNameTarget.textContent = name;
    this.selectedOrgTarget.classList.remove('hidden');
    this.inputTarget.value = '';
    this.hideResults();

  }

  clear() {
    this.organisationIdTarget.value = '';
    this.selectedOrgTarget.classList.add('hidden');
    this.selectedNameTarget.textContent = '';
  }

  showResults() {
    this.resultsTarget.classList.remove('hidden');
  }

  hideResults() {
    this.resultsTarget.classList.add('hidden');
  }

  handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.hideResults();
    }
  };

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}
